/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ShareAccountsDto { 
    id: number;
    accountId?: number;
    accountNumber?: string | null;
    userId?: number;
    memberId?: string | null;
    memberName?: string | null;
    memberType?: string | null;
    productId?: number;
    productName?: string | null;
    status?: string | null;
    openingDate?: string;
}

